module.exports = __webpack_public_path__ + "static/guvenlik-896481b5a44d958f1dd37db1fd3389ec.svg";